import { Pog } from "@CommonTypes/merchflow/pog/pog";
import { omniAtom } from "src/utils/atoms";

export const pagesS0PogAtom = omniAtom({
  key: "pages/s0/pog",
  value: null as Pog | null,
});
